import type { FlowGraph } from "./schema";

/** Bilingual voter-intent polling flow. */
export const SAMPLE_VOTER_FLOW: FlowGraph = {
  id: "voter-intent-v1",
  name: "Voter Intent Poll (EN/ES)",
  entry: "intro",
  version: 1,
  nodes: {
    intro: {
      id: "intro",
      kind: "message",
      label: "Greeting",
      body: {
        en: "Hi {firstName}, this is {clientName}. We have 3 quick questions about the upcoming election. Reply STOP to opt out.",
        es: "Hola {firstName}, somos {clientName}. Tenemos 3 preguntas rápidas sobre las próximas elecciones. Responda STOP para cancelar.",
      },
      next: "q1",
    },
    q1: {
      id: "q1",
      kind: "question",
      label: "Likelihood to vote",
      prompt: {
        en: "How likely are you to vote? Reply 1=Definitely, 2=Probably, 3=Unsure, 4=No",
        es: "¿Qué tan probable es que vote? Responda 1=Seguro, 2=Probablemente, 3=No sé, 4=No",
      },
      answerKey: "likelihood",
      choices: [
        { id: "definitely", label: { en: "1", es: "1" }, aliases: ["definitely", "seguro", "yes", "si", "sí"] },
        { id: "probably",   label: { en: "2", es: "2" }, aliases: ["probably", "probablemente"] },
        { id: "unsure",     label: { en: "3", es: "3" }, aliases: ["unsure", "no se", "no sé", "maybe"] },
        { id: "no",         label: { en: "4", es: "4" }, aliases: ["no"] },
      ],
      next: "branch_likelihood",
      fallback: "q1",
    },
    branch_likelihood: {
      id: "branch_likelihood",
      kind: "branch",
      label: "Route by likelihood",
      rules: [
        { when: { answerKey: "likelihood", in: ["no"] }, goto: "tag_unlikely" },
        { when: { answerKey: "likelihood", in: ["unsure"] }, goto: "tag_persuadable" },
      ],
      default: "q2",
    },
    tag_unlikely: { id: "tag_unlikely", kind: "tag", label: "Tag unlikely", add: ["unlikely_voter"], next: "thanks_short" },
    tag_persuadable: { id: "tag_persuadable", kind: "tag", label: "Tag persuadable", add: ["persuadable"], next: "q2" },
    q2: {
      id: "q2",
      kind: "question",
      label: "Top issue",
      prompt: {
        en: "What issue matters most to you? 1=Economy 2=Housing 3=Education 4=Healthcare 5=Other",
        es: "¿Qué tema le importa más? 1=Economía 2=Vivienda 3=Educación 4=Salud 5=Otro",
      },
      answerKey: "issue",
      choices: [
        { id: "economy",    label: { en: "1", es: "1" } },
        { id: "housing",    label: { en: "2", es: "2" } },
        { id: "education",  label: { en: "3", es: "3" } },
        { id: "healthcare", label: { en: "4", es: "4" } },
        { id: "other",      label: { en: "5", es: "5" } },
      ],
      next: "q3",
      fallback: "q2",
    },
    q3: {
      id: "q3",
      kind: "question",
      label: "Contact preference",
      prompt: {
        en: "May we follow up about volunteering? Reply YES or NO.",
        es: "¿Podemos contactarle sobre voluntariado? Responda SI o NO.",
      },
      answerKey: "followup",
      choices: [
        { id: "yes", label: { en: "YES", es: "SI" }, aliases: ["yes", "y", "si", "sí"] },
        { id: "no",  label: { en: "NO",  es: "NO" }, aliases: ["no", "n"] },
      ],
      next: "branch_followup",
      fallback: "thanks_full",
    },
    branch_followup: {
      id: "branch_followup",
      kind: "branch",
      label: "Route by followup",
      rules: [{ when: { answerKey: "followup", equals: "yes" }, goto: "escalate" }],
      default: "thanks_full",
    },
    escalate: {
      id: "escalate",
      kind: "agent_escalation",
      label: "Send to volunteer coordinator",
      queue: "volunteer_followup",
      note: { en: "Wants volunteer follow-up", es: "Quiere seguimiento de voluntariado" },
      next: "thanks_full",
    },
    thanks_full: {
      id: "thanks_full",
      kind: "message",
      label: "Thanks (full)",
      body: {
        en: "Thank you for your time. Reply STOP to opt out.",
        es: "Gracias por su tiempo. Responda STOP para cancelar.",
      },
      next: "done",
    },
    thanks_short: {
      id: "thanks_short",
      kind: "message",
      label: "Thanks (short)",
      body: {
        en: "Thanks — we appreciate your response. Reply STOP to opt out.",
        es: "Gracias por su respuesta. Responda STOP para cancelar.",
      },
      next: "done",
    },
    done: { id: "done", kind: "completion", label: "End" },
  },
};
